/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';

import './styles/styles.css';
import background from '../assets/images/trees-background.png';
import SEO from './SEO';
import { createLead } from '../graphql/mutations';
import { FACILITIES, FACILITY_KEYS, facilityIdFor } from '../utils/facilities';

const heroWrapperStyle = {
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
};

const heroImageStyle = {
  width: '100%',
  display: 'block',
};

const heroOverlayStyle = {
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(to bottom, rgba(0,0,0,0.45), rgba(0,0,0,0.65))',
};

const heroCenteredStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#FFFFFF',
  textAlign: 'center',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const heroTitleStyle = {
  fontSize: 36,
  fontWeight: 700,
  marginBottom: 8,
};

const heroSubtitleStyle = {
  fontSize: 16,
  opacity: 0.9,
};

const cardsRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 24,
  justifyContent: 'center',
  margin: '32px auto 48px',
  maxWidth: 1000,
  padding: '0 16px',
  boxSizing: 'border-box',
};

const cardStyle = {
  flex: '1 1 260px',
  minWidth: 260,
  maxWidth: 360,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 20,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
  fontFamily: 'Raleway, sans-serif',
};

const cardTitleStyle = {
  fontSize: 20,
  fontWeight: 600,
  marginBottom: 8,
};

const cardTextStyle = {
  fontSize: 14,
  opacity: 0.9,
  marginBottom: 12,
  lineHeight: 1.6,
};

const formFieldStyle = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 10,
};

const formLabelStyle = {
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: 0.7,
  opacity: 0.8,
  marginBottom: 4,
};

const formInputStyle = {
  borderRadius: 8,
  border: '1px solid rgba(255,255,255,0.25)',
  padding: '8px 10px',
  backgroundColor: 'rgba(0,0,0,0.15)',
  color: '#F5F5FA',
  fontFamily: 'Raleway, sans-serif',
  fontSize: 14,
};

const smallNoteStyle = {
  fontSize: 11,
  opacity: 0.75,
  marginTop: 6,
};

const successTextStyle = {
  fontSize: 13,
  opacity: 0.9,
  marginTop: 10,
  backgroundColor: 'rgba(64, 199, 120, 0.12)',
  padding: '8px 10px',
  borderRadius: 8,
};
const buttonRowStyle = {
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  marginTop: 12,
};

const baseButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 42,
  padding: '0 18px',
  borderRadius: 999,
  fontWeight: 700,
  fontSize: 14,
  fontFamily: 'Raleway, sans-serif',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'all 0.18s ease',
};

const primaryButtonStyle = {
  ...baseButtonStyle,
  border: 'none',
  color: '#FFFFFF',
  background: '#7b1fa2',
  boxShadow: '0 10px 24px rgba(123, 31, 162, 0.28)',
};

const secondaryButtonStyle = {
  ...baseButtonStyle,
  color: '#EBD7FF',
  border: '1px solid rgba(235, 215, 255, 0.4)',
  background: 'rgba(255,255,255,0.06)',
};

export default class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailSent: false,
      submitError: false,
      submitting: false,
      name: '',
      email: '',
      message: '',
      region: '',
    };
  }

  onFormSubmit = async (event) => {
    event.preventDefault();
    const { name, email, message, region } = this.state;
    this.setState({ submitting: true, submitError: false });
    try {
      await API.graphql({
        query: createLead,
        variables: {
          input: {
            id: uuidv4(),
            facilityID: facilityIdFor(region),
            name: name.trim(),
            email: email.trim() || null,
            notes: message.trim() || null,
            dateCreated: new Date().toISOString().slice(0, 10),
            status: 'new',
          },
        },
        authMode: 'AWS_IAM',
      });
      this.setState({ emailSent: true, submitting: false });
    } catch (err) {
      console.error('Failed to submit contact form:', err);
      this.setState({ submitError: true, submitting: false });
    }
  };

  onNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  onEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  onMessageChange = (event) => {
    this.setState({ message: event.target.value });
  };

  onRegionChange = (event) => {
    this.setState({ region: event.target.value });
  };

  render() {
    const { emailSent, submitError, submitting, name, email, message, region } = this.state;

    return (
      <>
        <SEO
          title="Contact Bins Storage | Berkeley & Richmond Valet Storage"
          description="Contact Bins Storage for valet storage support, partnerships, or reservation help across San Francisco, Berkeley, and Richmond."
          path="/Contact"
        /> 
      <div>
        {/* Hero section */}
        <div style={heroWrapperStyle}>
          <img
            src={background}
            style={heroImageStyle}
            alt="Trees background"
          />
          <div style={heroOverlayStyle} />
          <div style={heroCenteredStyle}>
            <h1 style={heroTitleStyle}>Contact Us</h1>
            <p style={heroSubtitleStyle}>
              We&apos;re here to help with storage, partnerships, and support.
            </p>
          </div>
        </div>

        {/* Content cards */}
        <div style={cardsRowStyle}>
          {/* Get Storage / Contact form card */}
          <div style={cardStyle}>
            <h2 style={cardTitleStyle}>Get Storage Today</h2>
            <p style={cardTextStyle}>
              Have questions or need more information? Send us a note and we&apos;ll
              help you get started with Bins Storage.
            </p>

            <form onSubmit={this.onFormSubmit}>
              <div style={formFieldStyle}>
                <label htmlFor="inputName" style={formLabelStyle}>
                  Name
                </label>
                <input
                  id="inputName"
                  type="text"
                  value={name}
                  onChange={this.onNameChange}
                  style={formInputStyle}
                  placeholder="Your name"
                  required
                />
              </div>

              <div style={formFieldStyle}>
                <label htmlFor="inputEmail" style={formLabelStyle}>
                  Email
                </label>
                <input
                  id="inputEmail"
                  type="email"
                  value={email}
                  onChange={this.onEmailChange}
                  style={formInputStyle}
                  placeholder="you@example.com"
                  required
                />
              </div>

              <div style={formFieldStyle}>
                <label htmlFor="inputRegion" style={formLabelStyle}>
                  Region
                </label>
                <select
                  id="inputRegion"
                  value={region}
                  onChange={this.onRegionChange}
                  style={formInputStyle}
                  required
                >
                  <option value="">Choose your region</option>
                  {FACILITY_KEYS.map(key => (
                    <option key={key} value={key}>{FACILITIES[key].label}</option>
                  ))}
                </select>
              </div>

              <div style={formFieldStyle}>
                <label htmlFor="messageContent" style={formLabelStyle}>
                  Message
                </label>
                <textarea
                  id="messageContent"
                  rows="4"
                  value={message}
                  onChange={this.onMessageChange}
                  style={{ ...formInputStyle, resize: 'vertical' }}
                  placeholder="Tell us how we can help"
                  required
                />
              </div>

              <div style={buttonRowStyle}>
                <button
                  type="submit"
                  disabled={submitting}
                  style={{ ...primaryButtonStyle, opacity: submitting ? 0.7 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }}
                  onMouseEnter={(e) =>
                    !submitting && (e.currentTarget.style.transform = 'translateY(-2px)')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = 'translateY(0px)')
                  }
                >
                  {submitting ? 'Sending…' : 'Send Message'}
                </button>
              </div>

              {emailSent && (
                <div style={successTextStyle}>
                  Thanks for reaching out! We&apos;ll get back to you shortly.
                </div>
              )}

              {submitError && (
                <div style={{ ...successTextStyle, color: '#E11D48' }}>
                  Something went wrong sending your message. Please email us at <a href="mailto:hello@bins-storage.com" style={{ color: '#AAB5E0' }}>hello@bins-storage.com</a>.
                </div>
              )}

              <div style={smallNoteStyle}>
                Prefer to book directly? You can also{' '}
                <a
                  href="/Download"
                  style={{ color: '#AAB5E0', textDecoration: 'underline' }}
                >
                  reserve storage online
                </a>
                .
              </div>
            </form>
          </div>

          {/* Partner with us card */}
          <div style={cardStyle}>
            <h2 style={cardTitleStyle}>Partner With Us</h2>
            <p style={cardTextStyle}>
              Interested in partnering with Bins? We work with buildings,
              universities, and businesses to provide seamless storage solutions.
            </p>
            <div style={buttonRowStyle}>
            <Link
              to="/Partners"
              style={secondaryButtonStyle}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0px)')
              }
            >
              Learn More
            </Link>
            </div>
            <p style={cardTextStyle}>
              Email us at:
              <br />
              <strong>contact@bins-storage.com</strong>
            </p>
          </div>

          {/* Help / support card */}
          <div style={cardStyle}>
            <h2 style={cardTitleStyle}>Need Help?</h2>
            <p style={cardTextStyle}>
              For order issues, account questions, or general support, our team
              is just an email away.
            </p>
            <p style={cardTextStyle}>
              Support:
              <br />
              <strong>help@bins-storage.com</strong>
            </p>
            <p style={smallNoteStyle}>
              We typically respond within one business day.
            </p>
          </div>
        </div>
      </div>
    </>
    );
  }
}
